export default __webpack_public_path__ + "4dc6f0c05adf10c09c127b0e608cb9cc.png";